import useEmblaCarousel from 'embla-carousel-react';
import { useState, useCallback, useEffect } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CompareSlider from '../Slider/CompareSlider';
import Typography from '@mui/material/Typography'

export default function CompareGallery({ imageSet, height, dontShow }) {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, slidesToScroll: 1 });

    const scrollTo = useCallback((index) => {
        if (emblaApi) emblaApi.scrollTo(index);
        setSelectedIndex(index);
    }, [emblaApi]);

    const scrollPrev = () => {
        const prevIndex = selectedIndex === 0 ? imageSet.length - 1 : selectedIndex - 1;
        scrollTo(prevIndex);
    };

    const scrollNext = () => {
        const nextIndex = selectedIndex === imageSet.length - 1 ? 0 : selectedIndex + 1;
        scrollTo(nextIndex);
    };


    useEffect(() => {
        if (!emblaApi) return;
        emblaApi.on('select', () => {
            setSelectedIndex(emblaApi.selectedScrollSnap());
        });
    }, [emblaApi]);


    return (
        <Box>
            {/* Main CompareSlider */}
            <Box sx={{ width: '100%', height: height ?? 'auto', mb: 4 }} position={'relative'}>
                {
                    dontShow &&
                    (
                        <Box position={'absolute'} width={'90%'} top={20} display={'flex'} justifyContent={'space-between'} zIndex={2} sx={{ transform: 'translateX(5%)' }}>
                            <Typography variant="body1" component={'p'} color='#000'>Before</Typography>
                            <Typography variant="body1" component={'p'} color='#000'>After</Typography>
                        </Box>
                    )

                }
                <CompareSlider height={height} imageSet={imageSet[selectedIndex]} />
            </Box>
            {/* Thumbnail Carousel */}
            <Box sx={{ position: 'relative', width: '60%', mx: 'auto', overflow: 'visible' }}>
                {/* Arrows */}
                <IconButton onClick={scrollPrev} sx={{ position: 'absolute', top: '50%', left: '-35%', transform: 'translateY(-50%)', zIndex: 2 }}>
                    <ArrowBackIosNewIcon htmlColor='#606d6f' fontSize='large' />
                </IconButton>

                <IconButton onClick={scrollNext} sx={{ position: 'absolute', top: '50%', right: '-35%', transform: 'translateY(-50%)', zIndex: 2 }}>
                    <ArrowForwardIosIcon htmlColor='#606d6f' fontSize='large' />
                </IconButton>
                {/* Embla Carousel */}
                <Box ref={emblaRef} sx={{ overflow: 'hidden' }}>
                    <Box sx={{ display: 'flex' }}>
                        {imageSet.map((item, index) => (
                            <Box key={index} sx={{ flex: '0 0 33.3333%', cursor: 'pointer' }} onClick={() => scrollTo(index)}>
                                <Box
                                    component="img"
                                    src={item.before}
                                    alt={`Thumbnail ${index + 1}`}
                                    loading="lazy"
                                    sx={{ width: '100%', height: 125, objectFit: 'cover' }}
                                />
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
